import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  DropDownListComponent,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import { BiX } from 'react-icons/bi';
import { BsCheck2 } from 'react-icons/bs';
import { all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';

import './security.css';
import { getCompany } from '../../../services/Company/CompanyServices';
import { AddDepartment, DeleteDepartment, EditDepartment, getDepartment } from '../../../services/Department/DepartmentServices';
interface IState {
  departmentData: any;
  companyData: any;
}
interface IProps {
  GridHeight?: any;
}
export class CompanyDepartment extends Component<IProps, IState> {
  private departmentGrid: GridComponent;
  public validationRule: Object = { required: true };
  private dropDownListObjectOrganizationCode: any;
  private dropDownListObjectDepartmentStatus: any;
  constructor(props: IProps) {
    super(props);
    this.departmentGrid = new GridComponent(props);
    this.state = {
      departmentData: [],
      companyData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  SavePointDelete(obje: any) {
    const obj = JSON.stringify({
      department_id: obje[0].department_id,
    });
   DeleteDepartment(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getDepartment();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  SavePointAdd(data: any) {
    let status = this.dropDownListObjectDepartmentStatus.checked;
    let organization = this.dropDownListObjectOrganizationCode;
    if (organization.text === (undefined || null)) {
      Message.error('Can not be empty organization code');
      this.getDepartment();
      return false;
    }
    loadingShow(true, 'Adding');
    const obj = {
      status: status,
      description: data.description,
      department_code: data.department_code,
      organization_id: organization.value.toString(),
      organization_code: organization.text,
      app: 'UWORK',
      created_by: all_information.user_id,
      creation_date: new Date(),
    };
   AddDepartment(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getDepartment();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  SavePointEdit(data: any) {
    let status = this.dropDownListObjectDepartmentStatus.checked;
    let organization = this.dropDownListObjectOrganizationCode;
    if (organization.text === (undefined || null)) {
      Message.error('Can not be empty organization code');
      this.getDepartment();
      return false;
    }
    loadingShow(true, 'Adding');

    const obj = {
      status: status,
      description: data.description,
      department_id: data.department_id,
      department_code: data.department_code,
      organization_id: organization.value.toString(),
      organization_code: organization.text,
      app: 'UWORK',
      created_by: all_information.user_id,
      creation_date: new Date(),
    };
   EditDepartment(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getDepartment();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  async componentDidMount() {
    loadingShow(true);
    setTimeout(() => {
      loadingShow(false);
    }, 10000);
    await this.getDepartment();
    await this.getCompany();

    loadingShow(false);
  }
  async getCompany() {
    await getCompany()
      .then((el) => {
        this.setState({ companyData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  async getDepartment() {
   getDepartment()
      .then((el) => {
        this.setState({ departmentData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getDepartment();
    }
    if (this.departmentGrid && args.item.id === 'gridDepartment_excelexport') {
      this.departmentGrid.excelExport();
    }
  }
  actionBeginDepartment(args: any) {
    if (args.action === 'add') {
      this.SavePointAdd(args.data);
    } else if (args.action === 'edit') {
      this.SavePointEdit(args.data);
    } else if (args.requestType === 'delete') {
      this.SavePointDelete(args.data);
    }
  }
  private istatustemplate(args: any) {
    let isChecked = args.status;
    return (
      <div>
        {isChecked ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }
  private isStatustemplateEditing(args: any) {
    return (
      <SwitchComponent
        checked={args.status}
        ref={(scope) => (this.dropDownListObjectDepartmentStatus = scope)}
      />
    );
  }
  private CompanyTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Company Name'
        text={args.organization_code}
        value={args.organization_id}
        fields={{
          text: 'organization_code',
          value: 'organization_id',
        }}
        dataSource={this.state.companyData}
        ref={(scope) => (this.dropDownListObjectOrganizationCode = scope)}
      />
    );
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridDepartment'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.departmentData}
          height='calc(-220px + 100vh)'
          ref={(theGrid: GridComponent) => (this.departmentGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          enablePersistence
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginDepartment.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='organization_code'
              headerText='Company Name'
              textAlign='Left'
              editType='dropdownedit'
              editTemplate={this.CompanyTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='department_code'
              headerText='Department Name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />

            <ColumnDirective
              field='status'
              headerText='Status'
              textAlign='Left'
              template={this.istatustemplate.bind(this)}
              editTemplate={this.isStatustemplateEditing.bind(this)}
              width={'30px'}
              minWidth={'30px'}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default CompanyDepartment;
